<div class="automation-rules">

  <sc-master-detail [selection]="[selectedProfile]" [data]="profiles" (selectionChanged)="onSelectionChanged($event);"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);" [newStyle]="true">
    <sc-scroll-pane>
      <form [formGroup]="detailsForm" *ngIf="selectedProfile != null">
        <div class="automation-rule-details no-field-space">
          <mat-tab-group>
            <mat-tab
              [label]="'base data' | translate: ['tmc-yard.widget.transport-creation-profiles.base-data', translationService.language]">
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="active"
                [label]="'active' | translate: ['tmc-yard.widget.transport-creation-profiles.active', translationService.language]">
              </sc-checkbox-field>
              <sc-flex>
                <sc-checkbox-field formControlName="hasQrCode"
                  [label]="'create-qr-code' | translate: ['tmc-yard.widget.transport-creation-profiles.has-qr-code', translationService.language]">
                </sc-checkbox-field>

                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <button [disabled]="!selectedProfile.hasQrCode" mat-stroked-button (click)="createPDF()">{{'create
                  pdf' | translate:
                  ['tmc-yard.widget.transport-creation-profiles.create-pdf', translationService.language]}}</button>
              </sc-flex>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-string-field formControlName="name" [required]="true"
                [label]="'name' | translate: ['tmc-yard.widget.transport-creation-profiles.name', translationService.language]">
              </sc-string-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="hasActionTablet"
                [label]="'use-in-action-tablet' | translate: ['tmc-yard.widget.transport-creation-profiles.has-action-tablet', translationService.language]">
              </sc-checkbox-field>

              <ng-container *ngIf="displayNameVisible">
                <sc-content-spacer [vertical]="true"></sc-content-spacer>
                <sc-string-field formControlName="displayName" [required]="true"
                  [label]="'display name' | translate: ['tmc-yard.widget.transport-creation-profiles.display-name', translationService.language]">
                </sc-string-field>
              </ng-container>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
            </mat-tab>
            <mat-tab
              [label]="'properties' | translate: ['tmc-yard.widget.transport-creation-profiles.properties', translationService.language]">
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="allowParallelAccess"
                [label]="'allow parallel access' | translate: ['tmc-yard.widget.transport-creation-profiles.allow-parallel-access', translationService.language]">
              </sc-checkbox-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="withRouting"
                [label]="'with routing' | translate: ['tmc-yard.widget.transport-creation-profiles.with-routing', translationService.language]">
              </sc-checkbox-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-read-only-field *ngIf="!numberPlateEnabled"
                [label]="'hash code' | translate: ['tmc-yard.widget.transport-creation-profiles.hash-code', translationService.language]"
                [value]="selectedProfile?.hashCode">
              </sc-read-only-field>
              <sc-content-spacer *ngIf="!numberPlateEnabled" [vertical]="true"></sc-content-spacer>
              <sc-string-field formControlName="carrier"
                [label]="'carrier' | translate: ['tmc-yard.widget.transport-creation-profiles.carrier', translationService.language]">
              </sc-string-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-string-field formControlName="driver"
                [label]="'driver' | translate: ['tmc-yard.widget.transport-creation-profiles.driver', translationService.language]">
              </sc-string-field>
              <sc-content-spacer *ngIf="!numberPlateEnabled" [vertical]="true"></sc-content-spacer>
              <sc-string-field *ngIf="!numberPlateEnabled" formControlName="numberPlate"
                [label]="'number plate' | translate: ['tmc-yard.widget.transport-creation-profiles.number-plate', translationService.language]">
              </sc-string-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-string-field formControlName="orderReference"
                [label]="'order reference' | translate: ['tmc-yard.widget.transport-creation-profiles.order-reference', translationService.language]">
              </sc-string-field>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-padding>
                <app-transport-options-panel [model]="transportOptionsPanelModel"></app-transport-options-panel>
              </sc-padding>

            </mat-tab>
            <mat-tab
              [label]="'number-plates' | translate: ['tmc-yard.widget.transport-creation-profiles.number-plates', translationService.language]">
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
              <sc-checkbox-field formControlName="hasNumberPlateList"
                [label]="'capture number-plate-list' | translate: ['tmc-yard.widget.transport-creation-profiles.has-number-plate-list', translationService.language]">
              </sc-checkbox-field>
              <app-number-plate *ngIf="numberPlateEnabled" [selectedProfile]="selectedProfile"
                (deleteClicked)="deleteNumberPlate($event)" (changeActiveClicked)="changeNumberPlateActive($event)"
                (addNewNumberPlateClicked)="addNewNumberPlate($event)"></app-number-plate>
            </mat-tab>
          </mat-tab-group>
        </div>

      </form>
    </sc-scroll-pane>

    <ng-template masterDetailToolbar>

      <button mat-stroked-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled">
        {{'cancel' | translate: ['tmc-yard.action.cancel', translationService.language]}}</button>
      <div class="spacer"></div>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="config-changed-button" (click)="save()" [disabled]="!saveEnabled">{{'save' |
        translate: ['tmc-yard.action.save', translationService.language]}}</button>

    </ng-template>
  </sc-master-detail>

</div>
